import { EntityId, EntityIdParams } from '@Models';
import { UnitOptionView } from './unit-option.view';

export class UnitView extends EntityId<number> {
  unitOptions: UnitOptionView[];

  constructor(params: UnitViewParams) {
    super(params);

    this.unitOptions = params.unitOptions;
  }
}

export type UnitViewParams = EntityIdParams<number> & {
  unitOptions: UnitOptionView[];
};
